import { useState } from "react";
import MuiSwitch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

interface SwitchProps {
  label: string;
  checked?: boolean; // Controlado
  defaultChecked?: boolean; // No controlado
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  color?: "blue" | "gray"; // Prop para el tema de color
}

const Switch: React.FC<SwitchProps> = ({
  label,
  checked, // Si se pasa, es controlado
  defaultChecked = false,
  disabled = false,
  onChange,
  color = "blue", // Por defecto azul
}) => {
  const [internalChecked, setInternalChecked] = useState(defaultChecked);
  
  // Si está controlado, usar checked; si no, usar estado interno
  const isChecked = checked !== undefined ? checked : internalChecked;

  const handleChange = (_: unknown, nextChecked: boolean) => {
    if (disabled) return;

    if (checked === undefined) {
      setInternalChecked(nextChecked);
    }

    onChange?.(nextChecked);
  };

  const muiColor = color === "blue" ? "primary" : "default";

  // Si el label viene vacío, renderizar solo el switch sin reservar espacio.
  if (!label) {
    return (
      <MuiSwitch
        checked={isChecked}
        onChange={handleChange}
        disabled={disabled}
        color={muiColor as any}
      />
    );
  }

  return (
    <FormControlLabel
      label={label}
      labelPlacement="start"
      disabled={disabled}
      sx={{
        width: "100%",
        margin: 0,
        display: "flex",
        justifyContent: "space-between",
        gap: 1,
        ".MuiFormControlLabel-label": {
          fontSize: "0.875rem",
          fontWeight: 500,
        },
      }}
      control={
        <MuiSwitch
          checked={isChecked}
          onChange={handleChange}
          disabled={disabled}
          color={muiColor as any}
        />
      }
    />
  );
};

export default Switch;
